import { select, put, call } from 'redux-saga/effects'
import DocumentsActions from '../reducers/documentsRedux'
import FilesActions from '../reducers/filesRedux'
import WorkflowActions from '../reducers/workflowRedux'
import { trackEvent } from '../utils/AnalyticsUtil'

export const getFileToBeRenamed = state => state.documents.fileToBeRenamed
export const getUploaderState = state => state.documents.uploaderState

export function* setCompletedFileViewed(api, action) {
    var response = yield call(api.setFileViewed, action.fileId, action.taxYear);
    if (response && response.ok) {
        response = yield call(api.getCompletedFileInfo, action.taxYear);
        if (response && response.ok) {
            yield put(FilesActions.setCompletedDocuments(action.taxYear, response.data))
        }
    } else {
        if (response.status === 404) {
            // TODO?!
        }
    }
}

export function* sendOneTimeSMS(api, action) {
    var response = yield call(api.sendOneTimeSMS, action.route || '/dashboard/documents', action.taxYear)

    var successResponse = action.uploaderState === 'sms_sending' ? 'sms_sent' : 'sms_resent'
    yield put(DocumentsActions.setUploaderState(true, response && response.ok ? successResponse : 'sms_failed'))
}

export function* renameIOSFile(api, action) {
    var fileToBeRenamed = yield select(getFileToBeRenamed)

    if (fileToBeRenamed) {
        yield call(api.renameIOSFile, fileToBeRenamed)
    }
}

export function* loadCompletedDocuments(api, action) {
    var response = yield call(api.getCompletedFileInfo, action.taxYear);
    if (response && response.ok) {
        yield put(FilesActions.setCompletedDocuments(action.taxYear, response.data))
    }
}

export function* setFileUploaded(api, action) {
    var response = yield call(api.setFileWasUploaded, action.taxYear);
    if (response && response.ok) {
        yield put(WorkflowActions.updateCaseState())
    }
}

export function* setUploadStepCompleted(api, action) {
    var response = yield call(api.uploadstepcompleted, action.taxYear, action.isComplete);
    if (response && response.ok) {
        trackEvent('OteUploadComplete', { taxYear: action.taxYear })
        yield put(WorkflowActions.updateCaseState())
    }
}

export function* loadDocumentsForReview(api, action) {
    var response = yield call(api.getDocumentsForReview, action.taxYear);
    if (response && response.ok) {
        yield put(FilesActions.setDocumentsForReview(action.taxYear, response.data))
    }
}

export function* setDocumentForReviewViewed(api, action) {
    var response = yield call(api.setFileViewed, action.fileId, action.taxYear);
    if (response && response.ok) {
        response = yield call(api.getDocumentsForReview, action.taxYear);
        if (response && response.ok) {
            yield put(FilesActions.setDocumentsForReview(action.taxYear, response.data))
        }
    } else {
        if (response.status === 404) {
            // TODO?!
        }
    }
}

export function* loadApprovalDocuments(api, action) {
    var response = yield call(api.getApprovalDocuments, action.taxYear);
    if (response && response.ok) {
        yield put(FilesActions.setApprovalDocuments(action.taxYear, response.data))
    }
}

export function* sendReviewCompleteMessage(api, action) {
    yield call(api.sendReviewCompleteMessage, action);    
}

export function* sendReviewCompleteMessageWetSignature(api, action) {
    yield call(api.sendReviewCompleteMessageWetSignature, action);
}

export function* getSuggestions(api, action) {
    var response = yield call(api.getSuggestions, action.taxYear);
    if (response && response.ok) {
        yield put(DocumentsActions.setSuggestions(response.data.suggestedDocs));
    }
}